import React, { useEffect, useState } from "react";
import { convertDateFormat, getBlog } from "../../Transformations/NewsList";

import { useParams } from "react-router-dom";
import FLoader from "../../Transformations/FLoader";
export default function FullBlog() {
	const [blogs, setBlogs] = useState(null);

	const { blogId } = useParams();

	useEffect(() => {
		const fetchData = async () => {
			const data = await getBlog(blogId);
			setBlogs(data);
		};
		fetchData();
	}, []);

	return (
		<div className="blog-content-page">
			<div className="blog-content-sec">
				{blogs ? (
					<div className="blog-content">
						<small className="newsview-date">
							{convertDateFormat(blogs.blog_date)}
						</small>
						<div className="blog-full">
							<div dangerouslySetInnerHTML={{ __html: blogs.blog_full }}></div>
						</div>
					</div>
				) : (
					<FLoader />
				)}
			</div>
			<aside className="contact-sec">
				<p>
					Setzen Sie sich mit uns in Verbindung und lassen Sie sich
					unverbindlich beraten.
				</p>
				<a className="link-button" href="/kontakt">
					Kontaktieren Sie uns
				</a>
			</aside>
		</div>
	);
}
